const nav = {
  home: 'Inicio',
  about: 'Nosotros',
  services: 'Servicios',
  consulting: 'Consultoría',
  products: 'Productos',
  contact: 'Contacto',
  academy: 'Academia'
};

export default nav;
